// Clears everything the app keeps in localStorage about the signed-in user and
// their organization — tokens, cached lookup lists (requesters, departments...),
// org/hierarchy settings, selected client/matter, recent and saved searches — so
// nothing from one session (or one firm) is left behind for the next person to
// sign in on this browser.
//
// Deny-by-default: every key is removed EXCEPT the pure layout preferences below,
// which hold no org data. A new cached value is therefore cleared automatically;
// only add a key here if it's a layout preference with no org/user data in it.
export const PRESERVED_PREFERENCE_KEYS = [
    'ft-inventory-column-widths',                 // ThreeColumnLayout column widths
    'customInventoryReport-columnVisibility',     // report column toggles
    'customInventoryReport-columnOrder',          // report column order
    'ft-panel-sizes',                             // multi-panel layout sizes
    'ft-navigator-sections'                       // multi-panel collapsed sections
];

export default function clearUserData(storage = window.localStorage) {
    const keys = [];
    for (let i = 0; i < storage.length; i++) {
        keys.push(storage.key(i));
    }
    keys
        .filter((key) => !PRESERVED_PREFERENCE_KEYS.includes(key))
        .forEach((key) => storage.removeItem(key));
}
